var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetroleum = function SvgPetroleum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-53 0 448 448"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.668 128c84.812 0 170.664-21.98 170.664-64S255.48 0 170.668 0 0 21.98 0 64s85.855 64 170.668 64m74.664-74.668h21.336c5.89 0 10.664 4.777 10.664 10.668s-4.773 10.668-10.664 10.668h-21.336c-5.89 0-10.664-4.777-10.664-10.668s4.773-10.668 10.664-10.668m0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.668 115.16c-37.484 24.438-101.852 34.172-160 34.172s-122.516-9.734-160-34.172v85.235A33.72 33.72 0 0 0 0 224c0 42.02 85.855 64 170.668 64s170.664-21.98 170.664-64a33.73 33.73 0 0 0-10.664-23.605zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.668 275.16c-37.484 24.438-101.852 34.172-160 34.172s-122.516-9.734-160-34.172v85.235A33.72 33.72 0 0 0 0 384c0 42.02 85.855 64 170.668 64s170.664-21.98 170.664-64a33.73 33.73 0 0 0-10.664-23.605zm0 0"
  })));
};
export default SvgPetroleum;